import { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { DriversState } from '../../types';

import { getDriverFilteredFuelAssignments } from '../operations/getDriverFilteredFuelAssignments';

import { STATUS_LOADING } from 'common/constants';

export const setDriverFilteredFuelAssignments = (builder: ActionReducerMapBuilder<DriversState>) => builder
  .addCase(getDriverFilteredFuelAssignments.pending, (state) => {
    state.filteredFuelAssignments.loadingStatus = STATUS_LOADING.load;
  })
  .addCase(getDriverFilteredFuelAssignments.fulfilled, (state, { payload }) => {
    const { data: { items, ...paging }, filter } = payload;
    state.filteredFuelAssignments.loadingStatus = STATUS_LOADING.done;
    state.filteredFuelAssignments.data = items;
    state.filteredFuelAssignments.paging = paging;
    state.filteredFuelAssignments.filter = filter;
  })
  .addCase(getDriverFilteredFuelAssignments.rejected, (state) => {
    state.filteredFuelAssignments.loadingStatus = STATUS_LOADING.error;
  });